<template>
  <router-view v-show="isReady" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  name: "App",
  setup() {
    const isReady = ref(false);

    onMounted(() => {
      setTimeout(() => {
        isReady.value = true;
      }, 500);
    });

    return {
      isReady,
    };
  },
});
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 确保内容始终从顶部开始，防止因高度变化导致的垂直居中跳动 */
}
</style>
